<div class="overlay-close" (click)="close()"></div>

<div class="cover-wrapper">
  <div class="icon-wrapper" (click)="backToDetails(!messageData?.isLiked)">
    @if (!messageData?.isLiked) {
      <img
        src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/tabs_assets%2Fwhiteheart_800x800.png?alt=media"
        alt=""
        class="fav-img"
        />
    }
    @if (messageData?.isLiked) {
      <img
        src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/tabs_assets%2Fredheart_800x800.png?alt=media"
        alt=""
        class="fav-img"
        />
    }

    <!-- add herted image here -->
  </div>

  <div class="text-container">
    <div style="display: flex; text-align: right; justify-content: flex-end; padding-right: 25px">
      <!-- <h3 class="hero-title"> <span class="highlighted-text">£20M Jackpot </span><br /> <small>to be won!</small>
    </h3> -->
    <!-- <h3 class="hero-title">{{ messageData?.extract }}</h3> -->

    <h3 class="hero-title">
      <span class="highlighted-text" [innerHTML]="messageData?.extract_label"></span>
    </h3>
    <!--  -->
  </div>
  <div class="main-title-wrapper">
    <!-- <p class="desc-text">Et has minim elitr intellegat. Mea aeterno eleifend antiopam ad, nam no suscipit quaerendum.
  </p> -->
  <p class="desc-text" [innerHTML]="messageData?.message_content"></p>

  <!-- message_content -->
</div>
<ion-button (click)="onCTA()" class="custom-btn">{{ messageData?.button_label }}</ion-button>
</div>
</div>
